import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ToolOutlined } from '@ant-design/icons';

export const PlaceholderScreen: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', padding: '40px' }}>
            <style>
                {`
                @keyframes float-tool {
                    0% { transform: translateY(0px) rotate(0deg); }
                    25% { transform: translateY(-10px) rotate(-10deg); }
                    50% { transform: translateY(0px) rotate(0deg); }
                    75% { transform: translateY(-10px) rotate(10deg); }
                    100% { transform: translateY(0px) rotate(0deg); }
                }
                .animated-icon {
                    animation: float-tool 4s ease-in-out infinite;
                    color: var(--color-primary, #1890ff);
                }
                `}
            </style>
            <Result
                icon={<ToolOutlined className="animated-icon" />}
                title="Under Construction"
                subTitle="We're actively building this page. Please check back soon!"
                extra={
                    <Button type="primary" onClick={() => navigate('/dashboard')}>
                        Back to Dashboard
                    </Button>
                }
            />
        </div>
    );
};
